// 半角スペースを全角スペースに変換
export const convertHalfToFullSpace = (value) => {
  if (typeof value !== 'string') return value;
  return value.includes(' ') ? value.replace(/ /g, '　') : value;
};

export const convertAllSpacesInObject = (obj) => {
  const result = {};
  for (const key in obj) {
    const value = obj[key];
    result[key] = typeof value === 'string' ? convertHalfToFullSpace(value) : value;
  }
  return result;
};

export const convertAllSpacesInArray = (arr) => {
  return arr.map(item => convertAllSpacesInObject(item));
};

// 半角スペース・全角スペースを削除
export const removeAllSpacesInString = (value) => {
  if (typeof value !== "string") return value;
  return value.replace(/[\s\u3000]+/g, "");
};

export const removeAllSpacesInObject = (obj) => {
  const result = {};
  for (const key in obj) {
    const value = obj[key];
    result[key] = typeof value === "string" ? removeAllSpacesInString(value) : value;
  }
  return result;
};

export const removeAllSpacesInArray = (arr) => {
  return arr.map(item => removeAllSpacesInObject(item));
};